import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useSendReportModalContentStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  flexGrow: {
    flexGrow: '1'
  },
  modalContent: {
    padding: '24px 40px'
  },
  personForm: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '& .MuiButton-root': {
      backgroundColor: palette.shades[100],
      marginLeft: '10px',
      padding: '12px',
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px'
      }
    }
  }
}));
export default useSendReportModalContentStyles;